import type { TemplateStatus, TripTemplate } from '@/types/tripTemplates';

/**
 * Effective moderation status for marketplace visibility.
 * Legacy curated templates (system/curator) without an explicit status are live.
 * Only community submissions default to pending when status is unset.
 */
export function resolveMarketplaceTemplateStatus(template: TripTemplate): TemplateStatus {
  if (template.status) {
    return template.status;
  }
  return template.createdBy === 'community' ? 'pending' : 'approved';
}
